import React from 'react';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '../utility/styles';

const noSettingsSelectionStyle = () => ({
  noResults: {
    margin: '10px',
  },
});

const useNoSettingsSelectionStyle = makeStyles(noSettingsSelectionStyle);

const NoSettingsSelection = () => {
  const classes = useNoSettingsSelectionStyle();

  return (
    <div>
      <Typography className={classes.noResults} variant="h3">
        No settings selected
      </Typography>
      <Typography className={classes.noResults} variant="h5">
        Select one of the settings on the left
      </Typography>
    </div>
  );
};

let _currentHRef: string | undefined = undefined;

export default withRouter((props: any) => {
  React.useEffect(
    () => () => {
      _currentHRef = location.href;
    },
    [],
  );
  if (location.href === _currentHRef) return null;
  _currentHRef = location.href;
  const { settings } = props;
  const { pageState } = props;

  const params = new URLSearchParams(location.search);
  requestAnimationFrame(() => {
    if (pageState?.__settings && (!settings || pageState.__settings.id !== settings.id)) pageState.__settings.deselect(true);
    if (pageState) pageState.__settings = settings;
    if (settings === null) return <NoSettingsSelection />;

    settings?.select(params.get('selectedItem') as string | null);
  });
  return null;
}) as React.ComponentType<any>;
